import { Component } from "solid-js";
import { A } from "@solidjs/router";
import { logoSrc } from "../stores/themeStore";
import { renderMarkdown } from "../utils/markdown";
import terms from "../content/legal/TERMS_OF_SERVICE.md?raw";
import privacy from "../content/legal/PRIVACY_POLICY.md?raw";

export const LegalPage: Component<{ doc: "terms" | "privacy" }> = (props) => {
  const src = () => (props.doc === "terms" ? terms : privacy);
  const siblingHref = () => (props.doc === "terms" ? "/privacy" : "/terms");
  const siblingLabel = () =>
    props.doc === "terms" ? "Privacy Policy" : "Terms of Service";

  return (
    <div class="min-h-screen bg-paper">
      <div class="mx-auto max-w-3xl px-4 py-12">
        <div class="mb-8 flex items-center justify-between">
          <A href="/" class="focus-ring rounded">
            <img src={logoSrc()} alt="Flowicity" class="w-10 h-10 rounded-md" />
          </A>
          <nav class="flex items-center gap-4 text-sm">
            <A
              href={siblingHref()}
              class="text-ink-2 hover:text-ink focus-ring rounded"
            >
              {siblingLabel()}
            </A>
            <A href="/" class="text-ink-2 hover:text-ink focus-ring rounded">
              Back to Flowicity
            </A>
          </nav>
        </div>
        <div
          class="prose prose-sm max-w-none"
          innerHTML={renderMarkdown(src())}
        />
      </div>
    </div>
  );
};
